export const PRESETS = {
  business: {
    key: "business",
    displayName: "Business Assistant",
    colors: {
      primary: "#4ECDC4",
      secondary: "#45B7B8",
      accent: "#4ECDC4",
      warning: "#F59E0B",
      error: "#EF4444",
      textOnPrimary: "#ffffff",
      bgGradient: "linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #334155 100%)",
    },
    features: { docsViewer: true, vapi: true },
  },
  hvac: {
    key: "hvac",
    displayName: "HVAC Expert",
    colors: {
      primary: "#FF6B35",
      secondary: "#FF8C42",
      accent: "#FF6B35",
      warning: "#FF8C42",
      error: "#b91c1c",
      textOnPrimary: "#ffffff",
      bgGradient: "linear-gradient(135deg, #1f2937 0%, #111827 60%, #374151 100%)",
    },
    features: { docsViewer: true, vapi: true, emergency: true, safety: true },
  },
  mentormind: {
    key: "mentormind",
    displayName: "MentorMind",
    colors: {
      primary: "#5B21B6", /* Premium deep dark bluish purple */
      secondary: "#6D28D9", /* Dark purple for gradients */
      accent: "#5B21B6",
      warning: "#f59e0b",
      error: "#ef4444",
      textOnPrimary: "#ffffff",
      bgGradient: "linear-gradient(135deg, #1a0b2e 0%, #16213e 50%, #0f3460 100%)",
    },
    features: { docsViewer: true, vapi: true, metrics: true, coaching: true },
  },
};

export function getPreset(key) {
  return PRESETS[key] || PRESETS.business;
}